import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const leadSchema = z.object({
  nome: z.string().trim().min(2).max(100),
  empresa: z.string().trim().min(2).max(120),
  contato: z.string().trim().min(6).max(200),
  whatsapp: z.string().trim().min(8).max(30),
  faturamento: z.string().trim().min(1).max(80),
  trafego: z.string().trim().min(1).max(20),
  investimento: z.string().trim().max(80).optional(),
  utmSource: z.string().trim().max(120).optional(),
  utmMedium: z.string().trim().max(120).optional(),
  utmCampaign: z.string().trim().max(120).optional(),
});

export const submitSiteDiagnostic = createServerFn({ method: "POST" })
  .inputValidator((input) => leadSchema.parse(input))
  .handler(async ({ data }) => {
    const { getServerSupabase } = await import("./supabase.server");
    const supabase = getServerSupabase();

    const utmSource = data.utmSource ?? null;
    const utmMedium = data.utmMedium ?? null;
    const utmCampaign = data.utmCampaign ?? null;

    const { error } = await supabase.from("site_diagnostic_leads").insert({
      name: data.nome,
      company: data.empresa,
      contact: data.contato,
      whatsapp: data.whatsapp,
      email: "",
      segment: "",
      revenue: data.faturamento,
      challenge: "",
      paid_traffic: data.trafego,
      media_investment: data.investimento || null,
      lead_owner: "",
      bottleneck: "",
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      landing_page: "/",
      status: "new",
    });

    if (error) {
      console.error("Site diagnostic insert error:", error);
      throw new Error("Não foi possível registrar a solicitação.");
    }

    // Keep the database copy even when the spreadsheet is temporarily unavailable.
    const lovableKey = process.env["LOVABLE_API_KEY"];
    const sheetsKey = process.env["GOOGLE_SHEETS_API_KEY"];
    if (!lovableKey || !sheetsKey) {
      console.error("Google Sheets connection is unavailable for site diagnostics.");
      return { success: true, sheetSynced: false };
    }

    const values = [[
      new Date().toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }),
      data.nome, data.empresa, data.contato, data.whatsapp,
      "", data.faturamento, data.trafego, data.investimento || "",
      utmSource || "", utmMedium || "", utmCampaign || "", "/", "new",
    ]];

    try {
      const response = await fetch(
        "https://connector-gateway.lovable.dev/google_sheets/v4/spreadsheets/1vuZkGcZUOciLjxeQfboEIjLDjykDGFHTRxigEojU4Ss/values/'Site Institucional'!A:N:append?valueInputOption=RAW&insertDataOption=INSERT_ROWS",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${lovableKey}`,
            "X-Connection-Api-Key": sheetsKey,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ values }),
        },
      );
      if (!response.ok) {
        console.error(`Google Sheets append failed [${response.status}]: ${await response.text()}`);
        return { success: true, sheetSynced: false };
      }
      return { success: true, sheetSynced: true };
    } catch (sheetError) {
      console.error("Google Sheets append failed:", sheetError);
      return { success: true, sheetSynced: false };
    }
  });
